var map = {
	"./avatar-1.png": 240,
	"./avatar-2.png": 241,
	"./avatar-3.png": 242,
	"./avatar-4.png": 243,
	"./avatar-5.png": 244,
	"./avatar-6.png": 245,
	"./avatar-7.png": 246,
	"./avatar-8.png": 247,
	"./avatar-pj.png": 387
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 616;


//////////////////
// WEBPACK FOOTER
// ./src/static/avatars ^\.\/avatar\-.*\.png$
// module id = 616
// module chunks = 0